export const GLOBAL_STATE = 'Modules'

export const MODULES = 'MODULES' as const
export const MODULES_CREATE = 'MODULES_CREATE' as const
export const MODULES_DELETE = 'MODULES_DELETE' as const
export const MODULES_LIST = 'MODULES_LIST' as const
export const MODULES_ALL = 'MODULES_ALL' as const
